import { ViteReactSSG } from 'vite-react-ssg'
import { routes } from './routes'
import './styles/fonts.css'
import './styles/global.css'
import './styles/hover.css'
import './styles/map.css'

// vite-react-ssg prerenders every route to static HTML at build time (for GoDaddy
// static hosting) and hydrates into a normal SPA in the browser.
export const createRoot = ViteReactSSG({ routes })
